import { Heart } from "lucide-react";
import { useFavorites } from "@/context/FavoritesContext";

export default function FavoriteButton({ testId, size = "sm" }) {
  const { has, toggle } = useFavorites();
  const active = has(testId);
  const s = size === "lg" ? "size-5" : "size-4";
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        toggle(testId);
      }}
      aria-label={active ? "Ta bort från favoriter" : "Spara som favorit"}
      data-testid={`fav-btn-${testId}`}
      className={`shrink-0 rounded-full p-1.5 hover:bg-muted transition-colors group ${
        active ? "text-accent" : "text-muted-foreground"
      }`}
    >
      <Heart className={`${s} transition-all ${active ? "fill-accent" : "group-hover:scale-110"}`} />
    </button>
  );
}
